{
  "version": 1,
  "asset_id": "0d991031-1039-4cad-a44b-c062c917833d",
  "project_id": "d3d6c30c-5e9b-4177-897c-1c6e2a8b33af",
  "url": "/__l5e/assets-v1/0d991031-1039-4cad-a44b-c062c917833d/olos-logo.png",
  "r2_key": "a/v1/d3d6c30c-5e9b-4177-897c-1c6e2a8b33af/0d991031-1039-4cad-a44b-c062c917833d/olos-logo.png",
  "original_filename": "olos-logo.png",
  "size": 76971,
  "content_type": "image/png",
  "created_at": "2026-07-28T14:30:20Z"
}
